<template>
  <v-row  justify="center">
    <v-dialog
      v-model="sessionNotice"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">Are you still there?</v-card-title>
        <v-card-text>You are about to be logged out. If you're not done with what you are doing, please click
          the 'Extend Session' button below. If you are done, either do nothing, or click the 'Logout' button
          below.
        </v-card-text>
        <v-card-actions>
          <v-btn
            data-testid="modal-session-logout-btn"
            class="modal-session-logout-btn"
            color="red darken-1"
            @click="logout"
          >
            Logout
          </v-btn>
          <v-spacer />
          <v-btn
            data-testid="modal-session-extend-btn"
            class="modal-session-extend-btn"
            color="green darken-1"
            :loading="loading"
            :disabled="loading"
            @click="extendUserSession"
          >
            Extend Session
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    sessionNotice() {
      return this.$store.state.auth.showSessionWarning;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout", {});
    },
    async extendUserSession() {
      this.loading = true;
      await this.$store.dispatch("auth/extendUserSession", {});
      this.loading = false;
    }
  }
};
</script>
